import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { CustomGroup, ChannelCustomGroup } from 'ops/common/models/custom-group';
import { SocketMiddlewareService } from './socket-middleware.service';

@Injectable({
    providedIn: 'root',
})
export class CustomGroupsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    getGroups(): Promise<CustomGroup[]> {
        return lastValueFrom(this.http.get<CustomGroup[]>(`${this.domain}/api/customGroup`));
    }

    getAllChannelsCustomGroups(): Promise<ChannelCustomGroup[]> {
        return lastValueFrom(
            this.http.get<ChannelCustomGroup[]>(`${this.domain}/api/customGroup/channels`),
        );
    }

    postGroup(data): Promise<any> {
        return lastValueFrom(
            this.http.post(`${this.domain}/api/customGroup`, {
                headers: this.headers,
                params: data,
            }),
        );
    }

    deleteGroup(groupId): Promise<any> {
        return lastValueFrom(
            this.http.delete(`${this.domain}/api/customGroup/${groupId}`, {
                responseType: 'text',
            }),
        );
    }

    updateGroup(data): Promise<any> {
        const groupId = data.id;
        return lastValueFrom(
            this.http.put(`${this.domain}/api/customGroup/${groupId}`, {
                headers: this.headers,
                params: data,
            }),
        );
    }
}
